const STATES = [
  { id: "enable", name: "Enable" },
  { id: "disable", name: "Disable" },
];
function getCommercialName(value) {
  if (!value) return [];
  return [
    "OR",
    ["name", "ilike", `%${value}%`],
    ["commercial_name", "ilike", `%${value}%`],
  ];
}
function layout() {
  const ctxView = {
    model: "vps.databases",
    domain: [],
    form_action: [],
    table_action: [],
    activeSearch: true,
    selectable: true,

    fields: {
      name: {
        type: "char",
        required: true,
      },
      vps: {
        type: "many2one",
        model: "vps.server",
        required: true,
        filter: true,
      },
      state: {
        type: "selection",
        tags: STATES,
        options: [
          { id: "enable", name: "Enable" },
          { id: "disable", name: "Disable" },
        ],
        readOnly: true,
        translate: true,
        filter: true,
      },
      customer: {
        type: "many2one",
        model: "party.party",
        searchable: true,
        filter: true,
        recSearch: getCommercialName,
      },
    },

    list: [
      { name: "customer", width: "25%" },
      { name: "name", width: "25%" },
      { name: "vps", width: "25%" },
      { name: "state", width: "25%" },
    ],

    form: [],
  };

  return ctxView;
}

export { layout };
